/* ---- runtime polyfills for older DApp browser WebViews ---- */
/* wagmi@3 (Object.hasOwn), @web3modal/core (Array.at, findLast, */
/* replaceAll), @walletconnect (randomUUID) use APIs that esbuild */
/* cannot transpile. Budget phone WebViews may lack these.        */
/* eslint-disable @typescript-eslint/no-explicit-any */
const _AP = Array.prototype as any
const _SP = String.prototype as any
const _O = Object as any
const _C = globalThis.crypto as any
if (!_AP.at) {
  _AP.at = function (n: number) {
    n = Math.trunc(n) || 0
    if (n < 0) n += this.length
    if (n < 0 || n >= this.length) return undefined
    return this[n]
  }
}
if (!_AP.findLast) {
  _AP.findLast = function (fn: Function, thisArg?: unknown) {
    for (let i = this.length - 1; i >= 0; i--) {
      if (fn.call(thisArg, this[i], i, this)) return this[i]
    }
  }
}
if (!_SP.replaceAll) {
  _SP.replaceAll = function (search: string, replace: string) {
    return this.split(search).join(replace)
  }
}
if (!_O.hasOwn) {
  _O.hasOwn = (obj: object, prop: PropertyKey) =>
    Object.prototype.hasOwnProperty.call(obj, prop)
}
if (_C && !_C.randomUUID) {
  _C.randomUUID = () => {
    const b = crypto.getRandomValues(new Uint8Array(16))
    b[6] = (b[6] & 0x0f) | 0x40 // version 4
    b[8] = (b[8] & 0x3f) | 0x80 // variant 10
    const h = [...b].map((x: number) => x.toString(16).padStart(2, '0')).join('')
    return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`
  }
}
/* eslint-enable @typescript-eslint/no-explicit-any */
